// @ts-nocheck
import React from 'react'
import cx from 'classnames'

import styles from './Textarea.module.scss'

export const Textarea = ({ className, ...props }) => (
  <textarea className={cx(styles.textarea, className)} {...props} />
)
